import { render, staticRenderFns } from "./ItemListAuctionLayout.vue?vue&type=template&id=5b3d3ae8&scoped=true"
import script from "./ItemListAuctionLayout.vue?vue&type=script&lang=js"
export * from "./ItemListAuctionLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3d3ae8",
  null
  
)

export default component.exports